import { useIterablePlacementId } from '@/components/common/IterableWrapper';
import { IterableBanner } from '@/components/common/IterableBanner';

export const IterableBannerSection = () => {
  const placementId = useIterablePlacementId();
  return <IterableBanner placementId={placementId} />;
};
